var exports = {
  "Qs": "content__ebK7W0",
  "wx": "header__je3F5Q",
  "nh": "titleSlot__RdMIAS",
  "Wl": "conversation__0LBSKx",
};

module.exports = exports;
